import { AccessRole, UserWithClaims, UserCreationForm } from '@synergetx/puppet-interview-types';
import * as Yup from 'yup';

export const getNewUser = (interviewId: string, groupId: string): UserCreationForm => {
    return {
        name: '',
        email: '',
        claims: { [`group_${groupId}`]: AccessRole.ASSESSOR },
    };
};

export const getUserFromExisting = (user: UserWithClaims): UserCreationForm => {
    return {
        name: user.name,
        email: user.email,
        claims: user.claims,
        id: user.id,
    };
};

export const addUserValidationSchema = Yup.object({
    name: Yup.string().required('A name is required').min(1, 'A name is required'),
    email: Yup.string()
        .matches(
            // FIXME: @john are these escapes necessary or not? What is our email test case that this code is fixing?
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            'A valid email is required',
        )
        .required(),
    desiredPassword: Yup.string(),
});
